'use client'

import { Box, Typography, Stack } from '@mui/material'
import { colorToHex } from '@helpers/colors/colorToHex'

export interface SideFilterSectionProps {
	title: string
	onClickFunction: (value: string | null) => void
	items: SideFilterSectionItemProps[]
}

export interface SideFilterSectionItemProps {
	label: string
	value: string | null
	color?: string
	selected: boolean
}

const SideFilters = ({ title, onClickFunction, items }: SideFilterSectionProps) => {
	return (
		<Box mb={8}>
			<Typography onClick={() => onClickFunction(null)} component="p" variant="size16" fontWeight="600" textTransform="uppercase">
				{title}
			</Typography>
			<Stack mt={2}>
				{items.map((item, index) => (
					<Stack
						onClick={() => onClickFunction(item.value)}
						p={2}
						direction="row"
						spacing={2}
						key={`status-filter-${index}`}
						alignItems="center"
						sx={{
							backgroundColor: (theme) => (item.selected ? theme.palette.gray.main : 'transparent'),
							cursor: 'pointer',
							'&:hover': { backgroundColor: (theme) => theme.palette.gray.main }
						}}
					>
						{item.color && (
							<Box
								sx={{
									width: '24px',
									height: '24px',
									backgroundColor: colorToHex(item.color),
									borderRadius: '100%'
								}}
							/>
						)}
						<Typography component="p" variant="size16" lineHeight={1.05}>
							{item.selected ? <strong>{item.label}</strong> : item.label}
						</Typography>
					</Stack>
				))}
			</Stack>
		</Box>
	)
}

export default SideFilters
